export default __webpack_public_path__ + "static/stemwerkz logo-9b5bdc8b7f999d07b7b3bb8d4d00ee46.png";